import React, { Component, Fragment } from 'react'
import { Row, Col, Collapse, Card, Icon, Breadcrumb, Divider } from 'antd'
import { Link } from 'react-router-dom'
import LangContext, { i18n } from 'modules/shared/context/langContext'

class Index extends Component {
  render() {
    const { checkMenuVisibility, web_endpoint, permissions } = this.props
    return (
      <>
        <div className="divider__web__content">
          <Divider />
        </div>
      </>
    )
  }
}

export default Index
